import { ReactSimpleComponentProps, RentChargeDetail } from '@/custom-types';
import { useMemo, useRef, useState } from 'react';
import {
  AddRentChargeFormModalContext,
  AddRentChargeFormModalContextProps,
} from './AddRentChargeFormModalContext';

export const AddRentChargeFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const rentChargeRef = useRef<RentChargeDetail | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddRentChargeFormModalContextProps, 'rentChargeData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      rentChargeRef.current = null
    },

    openModal: (rentChargeData?: RentChargeDetail) => {
      setOpen(true)

      if (rentChargeData) rentChargeRef.current =rentChargeData
    }
  }), [])

  return (
    <AddRentChargeFormModalContext.Provider value={{ ...actions, isOpen, rentChargeData: rentChargeRef.current}}>
      {children}
    </AddRentChargeFormModalContext.Provider>
  )
}